module.exports = __webpack_public_path__ + "static/media/icon-video-light.b4efa05c.svg";